import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

// ─── Data ────────────────────────────────────────────────────────────────────

const CRYPTO_SERVICES = [
  "Recovery",
  "Investment",
  "Buy/Sell",
  "Wallet Compromise",
  "Delayed Transaction",
  "Validation",
  "Transaction Glitch",
  "Claim Reward",
  "Swapping Issues",
  "Migration",
  "Maintenance",
  "TVLDrop",
  "Bridge",
  "Rectification",
  "Pending Withdrawal",
  "Slippage Error",
  "NFT Issues",
  "Airdrop",
  "Staking",
  "Token Issues",
  "Reauthentication",
];

// ─── Component ───────────────────────────────────────────────────────────────

function Cryptoservices() {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("show");
        else entry.target.classList.remove("show");
      });
    });

    containerRef.current
      .querySelectorAll(".hiddenns")
      .forEach((el) => observer.observe(el));

    return () => { observer.disconnect(); clearTimeout(t); };
  }, []);

  return (
    <div className="bg-[#F7F3EC] min-h-screen px-8 py-20">
      <div className="max-w-[900px] mx-auto">

        <p
          className="text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-4 transition-all duration-500"
          style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(10px)" }}
        >
          Crypto Services
        </p>

        <h1
          className="sc-serif text-[clamp(2rem,4vw,3rem)] text-[#1C1A16] leading-[1.1] mb-3 transition-all duration-500"
          style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(14px)", transitionDelay: "80ms" }}
        >
          Select the Crypto service you need.
        </h1>

        <p
          className="text-[#6B6457] text-[0.9rem] mb-14 transition-all duration-500"
          style={{ opacity: visible ? 1 : 0, transitionDelay: "160ms" }}
        >
          Tap any service below to file a complaint and begin your recovery process.
        </p>

        {/* Service tags */}
        <div ref={containerRef} className="flex flex-wrap gap-2.5">
          {CRYPTO_SERVICES.map((service) => (
            <NavLink
              key={service}
              to="/contact"
              className="hiddenns px-4 py-2 border border-[#D6CDB8] text-[#6B6457] text-[0.82rem] font-medium no-underline bg-transparent hover:bg-[#C4622D] hover:text-[#F7F3EC] hover:border-[#C4622D] transition-all"
            >
              {service}
            </NavLink>
          ))}
        </div>

        {/* Fallback prompt */}
        <div className="mt-16 p-6 bg-[#EDE7D9] border-l-[3px] border-[#C4622D]">
          <p className="text-[#6B6457] text-[0.85rem] leading-[1.7]">
            Don't see your specific issue listed?{" "}
            <NavLink
              to="/contact"
              className="text-[#C4622D] no-underline font-semibold hover:underline"
            >
              Contact us directly
            </NavLink>
            {" "}— our team handles all crypto-related situations.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Cryptoservices;